import { tw } from 'utils/classnames'

export interface SpinnerProps extends React.SVGAttributes<SVGSVGElement> {
  className?: string
  variant?: 'default' | 'inverse'
}

export const Spinner = ({ className, variant = 'default', ...props }: SpinnerProps) => {
  const gradientStyle = {
    default: 'conic-gradient(from 90deg,rgba(67, 41, 129, 1) 0deg,rgba(255, 255, 255, 1) 360deg)',
    inverse: 'conic-gradient(from 90deg,rgba(255, 255, 255, 0) 0deg,rgba(255, 255, 255, 1) 360deg)',
  }

  return (
    <span className="flex items-center justify-center">
      <svg
        className={tw('animate-spin w-6 h-6', className)}
        viewBox="0 0 80 80"
        fill="none"
        {...props}
      >
        <g clipPath="url(#cp)">
          <g transform="matrix(0 0.04 -0.04 0 40 40)">
            <foreignObject x="-1025" y="-1025" width="2050" height="2050">
              <div
                style={{
                  background: gradientStyle[variant],
                  height: '100%',
                  width: '100%',
                  opacity: 1,
                }}
              />
            </foreignObject>
          </g>
        </g>
        <path d="M80 40C80 62.0914 62.0914 80 40 80C17.9086 80 0 62.0914 0 40C0 17.9086 17.9086 0 40 0C62.0914 0 80 17.9086 80 40ZM8 40C8 57.6731 22.3269 72 40 72C57.6731 72 72 57.6731 72 40C72 22.3269 57.6731 8 40 8C22.3269 8 8 22.3269 8 40Z" />
        <defs>
          <clipPath id="cp">
            <path d="M80 40C80 62.0914 62.0914 80 40 80C17.9086 80 0 62.0914 0 40C0 17.9086 17.9086 0 40 0C62.0914 0 80 17.9086 80 40ZM8 40C8 57.6731 22.3269 72 40 72C57.6731 72 72 57.6731 72 40C72 22.3269 57.6731 8 40 8C22.3269 8 8 22.3269 8 40Z" />
          </clipPath>
        </defs>
      </svg>
    </span>
  )
}
